// * GET =====================================
export const VIEW_PRESET_GET_GET_BY_VIEW_ID = `/view_preset/get_by_view_id`;

// * PATCH ===================================
export const VIEW_PRESET_PATCH_SET_FLAGS = (viewPresetId: string) =>
  `/view_preset/set_flags/${viewPresetId}`;

export const VIEW_PRESET_PATCH_ADMIN_SET_FLAGS = (viewPresetId: string) =>
  `/view_preset/admin_set_flags/${viewPresetId}`;

// * POST ====================================
export const VIEW_PRESET_POST_GET_BY_CONTEXT_PROPERTIES = `/view_preset/get_by_context_properties`;

export const VIEW_PRESET_POST_UPDATE_BY_ID = `/view_preset/update_by_id`;

export const VIEW_PRESET_POST_ADMIN_LIST = `/view_preset/admin_list`;

export const VIEW_PRESET_POST_ADMIN_UPDATE = `/view_preset/admin_update`;

export const VIEW_PRESET_POST_ADMIN_COPY = `/view_preset/admin_copy`;

// * DELETE ==================================
export const VIEW_PRESET_DELETE_DELETE_BY_ID = (viewPresetId: string) =>
  `/view_preset/delete_by_id/${viewPresetId}`;

export const VIEW_PRESET_DELETE_ADMIN_DELETE = (viewPresetId: string) =>
  `/view_preset/admin_delete/${viewPresetId}`;

// * PUT =====================================
export const VIEW_PRESET_PUT_CREATE = `/view_preset/create`;

export const VIEW_PRESET_PUT_ADMIN_CREATE = `/view_preset/admin_create`;
